import { Result, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from 'components';
import EnquirySubmittedIcon from 'assets/images/enquiry-submitted-icon.svg';

interface PreClaimRequestSubmittedProps {
  enquiryReference: string;
}

export const PreClaimRequestSubmitted = ({ enquiryReference }: PreClaimRequestSubmittedProps): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Result
      icon={<img src={EnquirySubmittedIcon} alt="enquiry-submitted-icon" />}
      title={t('preAuthRequest.success.message')}
      subTitle={`${t('preAuthRequest.success.reference', { referenceNumber: enquiryReference })}`}
      extra={
        <Space direction="vertical">
          <Typography.Text>{t('preAuthRequest.success.description')}</Typography.Text>
          <PrimaryButton onClick={() => navigate('/home')}>{t('common.error.returnHome')}</PrimaryButton>
        </Space>
      }
    />
  );
};
